import * as React from 'react'

export interface IPageNotFoundProps {}

const PageNotFound = (props: IPageNotFoundProps) => {
	return <div>NOT FOUND</div>
}
export default PageNotFound
